/* Pointer drag-to-scroll for the Method scenes gallery (works
   alongside native touch swipe + scroll-snap). */
import { useEffect, useRef } from 'react'

export function useDragScroll() {
  const ref = useRef(null)
  useEffect(() => {
    const el = ref.current
    if (!el) return
    let down = false
    let startX = 0
    let startL = 0
    const dn = (e) => {
      down = true
      startX = e.pageX
      startL = el.scrollLeft
      el.classList.add('drag')
    }
    const mv = (e) => {
      if (!down) return
      el.scrollLeft = startL - (e.pageX - startX)
    }
    const up = () => {
      down = false
      el.classList.remove('drag')
    }
    el.addEventListener('pointerdown', dn)
    window.addEventListener('pointermove', mv)
    window.addEventListener('pointerup', up)
    return () => {
      el.removeEventListener('pointerdown', dn)
      window.removeEventListener('pointermove', mv)
      window.removeEventListener('pointerup', up)
    }
  }, [])
  return ref
}
